<script setup>
import { ref, onMounted, onUnmounted } from 'vue';

const isOnline = ref(navigator.onLine);

const updateOnlineStatus = () => {
  isOnline.value = navigator.onLine;
};

onMounted(() => {
  window.addEventListener('online', updateOnlineStatus);
  window.addEventListener('offline', updateOnlineStatus);
});

onUnmounted(() => {
  window.removeEventListener('online', updateOnlineStatus);
  window.removeEventListener('offline', updateOnlineStatus);
});
</script>

<template>
  <div v-if="!isOnline" class="offline-banner" role="alert" aria-live="assertive">
    <ion-icon icon="cloud-offline-outline" aria-hidden="true"></ion-icon>
    <span>{{ $t('network.offline') }}</span>
  </div>
</template>

<style scoped>
.offline-banner {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background: #a9071a;
  color: white;
  padding: 8px 16px;
  padding-top: calc(8px + env(safe-area-inset-top, 0px));
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  z-index: 99999;
  font-size: 0.9rem;
  font-weight: 500;
}

.offline-banner ion-icon {
  font-size: 1.2rem;
}
</style>
